import React, { useState, useEffect } from 'react';
import api from '../../../service/caller';
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
  CAlert,
  CForm,
  CFormCheck,
  CFormLabel,
  CSpinner
} from '@coreui/react';
import Adminprofil from '../../../assets/images/adminprofil.png';
import { CHeader, CContainer, CHeaderNav, CNavItem, CNavLink } from '@coreui/react';
import { FaDownload, FaUserShield, FaTrashAlt } from 'react-icons/fa';
import { BsArrowLeft, BsChevronRight } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const PatientDataPrivacy = () => {
  // States
  const [UserData, setUserData] = useState([]);
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [partialDeleteModalVisible, setPartialDeleteModalVisible] = useState(false);
  const [exportData, setExportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ visible: false, color: '', message: '' });
  const [dataTypes, setDataTypes] = useState({
    personal: false,
    symptoms: false,
    visits: false,
    family_history: false
  });
  
  const navigate = useNavigate();

  // Modal functions
  const toggleExportModal = () => setExportModalVisible(!exportModalVisible);
  const toggleDeleteModal = () => setDeleteModalVisible(!deleteModalVisible);
  const togglePartialDeleteModal = () => setPartialDeleteModalVisible(!partialDeleteModalVisible);

  // Function to log out the user
  const logoutUser = () => {
    localStorage.clear();
    // Add any other items that need to be removed from localStorage
    navigate('/patientLogin'); // Redirect to login page
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
        try {
            const response = await api.get('api/usersprofile');

            setUserData(response.data);
        } catch (error) {
            toast.error("Failed to fetch data");
        }
    };
    fetchLoggedUserData();
}, []);
  // Function to export data
  const handleExportData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token'); // Get authentication token
      const response = await api.post('/api/data/export', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        setExportData(response.data.data);
        toggleExportModal();
      } else {
        showAlert('danger', 'Export failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Error during data export:', error);
      showAlert('danger', 'An error occurred while exporting data');
    } finally {
      setLoading(false);
    }
  };

  // Function to download exported data
  const downloadExportData = () => {
    if (!exportData) return;
    
    const dataStr = JSON.stringify(exportData, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    const exportFileDefaultName = `patient-data-${new Date().toISOString().slice(0, 10)}.json`;
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  };

  // Function to delete (anonymize) all data
  const handleDeleteAllData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');
      const response = await api.delete('/api/data', {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        showAlert('success', response.data.message);
        toggleDeleteModal();
        
        // Log out the user after successfully deleting data
        setTimeout(() => {
          logoutUser();
        }, 2000); // Small delay to allow the user to see the success message
      } else {
        showAlert('danger', 'Deletion failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Error during data deletion:', error);
      showAlert('danger', 'An error occurred while deleting data');
    } finally {
      setLoading(false);
    }
  };

  // Function to handle checkbox changes for data types
  const handleCheckboxChange = (e) => {
    setDataTypes({
      ...dataTypes,
      [e.target.name]: e.target.checked
    });
  };

  // Function for partial data deletion
  const handlePartialDelete = async () => {
    // Check if at least one data type is selected
    const selectedTypes = Object.entries(dataTypes)
      .filter(([_, selected]) => selected)
      .map(([type, _]) => type);
    
    if (selectedTypes.length === 0) {
      showAlert('warning', 'Please select at least one data type to delete');
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');
      const response = await api.delete('/api/data/partial', {
        headers: { Authorization: `Bearer ${token}` },
        data: { dataTypes: selectedTypes }
      });

      if (response.data.success) {
        showAlert('success', response.data.message);
        togglePartialDeleteModal();
        // Reset checkboxes
        setDataTypes({
          personal: false,
          symptoms: false,
          visits: false,
          family_history: false
        });
        
        // If personal data is deleted, log out the user
        if (selectedTypes.includes('personal')) {
          setTimeout(() => {
            logoutUser();
          }, 2000);
        }
      } else {
        showAlert('danger', 'Partial deletion failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Error during partial data deletion:', error);
      showAlert('danger', 'An error occurred during partial data deletion');
    } finally {
      setLoading(false);
    }
  };

  // Function to display an alert
  const showAlert = (color, message) => {
    setAlert({
      visible: true,
      color,
      message
    });

    // Hide alert after 5 seconds
    setTimeout(() => {
      setAlert({ visible: false, color: '', message: '' });
    }, 5000);
  };

  return (
    <div className="dashboard-header">
      <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
          <CContainer fluid className="d-flex align-items-center">
              <div className='row w-100'>
                  <div className="pagetittle col">
                      <h4><b>Patient Management</b></h4>
                  </div>
                  <div className=' d-flex col justify-content-end'>
                      <CHeaderNav>
                          <CNavItem>
                              <CNavLink href="#" className="d-flex align-items-center ms-auto">
                                  <img src={UserData?.picture || Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                  <div>
                                      <span className="ms-2">{`${UserData?.firstname} ${UserData?.lastname}`}</span>
                                      <p className="ms-2">{UserData?.role?.name}</p>
                                  </div>
                              </CNavLink>
                          </CNavItem>
                      </CHeaderNav>
                  </div>
              </div>
          </CContainer>
      </CHeader>
      {/* Alert for notifications */}
      {alert.visible && (
        <CAlert color={alert.color} dismissible>
          {alert.message}
        </CAlert>
      )}

      <div className="patient-data-privacy mt-4">
        <CRow>
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader style={{ backgroundColor: '#DFEAF5' }}>
                <div className="d-flex align-items-center">
                  <Link to="/profile" className="btn btn-outline-primary me-3">
                    <BsArrowLeft /> Back
                  </Link>
                  <h4>Manage Your Personal Data</h4>
                </div>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-4">
                  <CCol md={4}>
                    <div className="info-card p-3 h-100 d-flex flex-column justify-content-between">
                      <div>
                        <h5 className="mb-3"><FaDownload className="me-2" /> Export Your Data</h5>
                        <p>Download a complete copy of your personal and medical data in JSON format.</p>
                      </div>
                      <CButton color="primary" onClick={handleExportData} disabled={loading}>
                        {loading ? <CSpinner size="sm" className="me-2" /> : <FaDownload className="me-2" />}
                        Export My Data
                      </CButton>
                    </div>
                  </CCol>
                  
                  <CCol md={4}>
                    <div className="info-card p-3 h-100 d-flex flex-column justify-content-between">
                      <div>
                        <h5 className="mb-3"><FaUserShield className="me-2" /> Partial Deletion</h5>
                        <p>Delete specific categories of data while maintaining your medical record.</p>
                      </div>
                      <CButton color="warning" onClick={togglePartialDeleteModal}>
                        Delete Specific Data
                      </CButton>
                    </div>
                  </CCol>
                  
                  <CCol md={4}>
                    <div className="info-card p-3 h-100 d-flex flex-column justify-content-between">
                      <div>
                        <h5 className="mb-3"><FaTrashAlt className="me-2" color="danger" /> Complete Anonymization</h5>
                        <p>Completely anonymize your patient record. Your personal data will be deleted.</p>
                      </div>
                      <CButton color="danger" onClick={toggleDeleteModal}>
                        Anonymize My Record
                      </CButton>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol xs={12}>
                    <div className="info-block p-4">
                      <h5>Important Information About Data Privacy</h5>
                      <ul>
                        <li>All your data is stored securely and confidentially</li>
                        <li>Anonymization of your record is irreversible</li>
                        <li>In accordance with GDPR, you can request access, rectification, or deletion of your data</li>
                        <li>For any questions regarding your data, contact our data protection officer</li>
                      </ul>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>

      {/* Data Export Modal */}
      <CModal visible={exportModalVisible} onClose={toggleExportModal}>
        <CModalHeader>
          <CModalTitle>Data Export</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {exportData ? (
            <>
              <p>Your data has been successfully prepared.</p>
              <p>Click the button below to download your data in JSON format.</p>
              <div className="mt-3 d-flex justify-content-center">
                <CButton color="success" onClick={downloadExportData}>
                  <FaDownload className="me-2" /> Download My Data
                </CButton>
              </div>
            </>
          ) : (
            <p>Preparing your data...</p>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={toggleExportModal}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      {/* Complete Data Deletion Modal */}
      <CModal visible={deleteModalVisible} onClose={toggleDeleteModal}>
        <CModalHeader>
          <CModalTitle>Patient Record Anonymization</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="alert alert-warning">
            <strong>Warning!</strong> This action is irreversible.
          </div>
          <p>
            By confirming this action, your personal data (name, surname, phone, address, email)
            will be anonymized. The medical history will be kept anonymously for statistical
            and legal purposes.
          </p>
          <p>
            Are you sure you want to proceed with anonymizing your patient record? You will be logged out after this action.
          </p>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={toggleDeleteModal}>
            Cancel
          </CButton>
          <CButton color="danger" onClick={handleDeleteAllData} disabled={loading}>
            {loading ? <CSpinner size="sm" className="me-2" /> : null}
            Confirm Anonymization
          </CButton>
        </CModalFooter>
      </CModal>

      {/* Partial Data Deletion Modal */}
      <CModal visible={partialDeleteModalVisible} onClose={togglePartialDeleteModal}>
        <CModalHeader>
          <CModalTitle>Partial Data Deletion</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>Select the types of data you want to delete:</p>
          <CForm>
            <div className="mb-3">
              <CFormCheck 
                id="personal" 
                name="personal"
                label="Personal data (phone, email, address)" 
                checked={dataTypes.personal}
                onChange={handleCheckboxChange}
              />
              <small className="form-text text-muted">
                Your contact details will be deleted, but your first and last name will be kept for identification. You will be logged out after deleting personal data.
              </small>
            </div>
            
            <div className="mb-3">
              <CFormCheck 
                id="symptoms" 
                name="symptoms"
                label="Symptoms history" 
                checked={dataTypes.symptoms}
                onChange={handleCheckboxChange}
              />
              <small className="form-text text-muted">
                All recorded symptoms will be erased from your record.
              </small>
            </div>
            
            <div className="mb-3">
              <CFormCheck 
                id="visits" 
                name="visits"
                label="Visit history" 
                checked={dataTypes.visits}
                onChange={handleCheckboxChange}
              />
              <small className="form-text text-muted">
                All visits and consultations will be deleted.
              </small>
            </div>
            
            <div className="mb-3">
              <CFormCheck 
                id="family_history" 
                name="family_history"
                label="Family medical history" 
                checked={dataTypes.family_history}
                onChange={handleCheckboxChange}
              />
              <small className="form-text text-muted">
                Information about family medical history will be deleted.
              </small>
            </div>
          </CForm>
          
          <div className="alert alert-info mt-3">
            <strong>Note:</strong> This action is irreversible. The selected data will be permanently deleted from your record.
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={togglePartialDeleteModal}>
            Cancel
          </CButton>
          <CButton color="warning" onClick={handlePartialDelete} disabled={loading}>
            {loading ? <CSpinner size="sm" className="me-2" /> : null}
            Delete Selected Data
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default PatientDataPrivacy;